module.exports = __webpack_public_path__ + "img/Phonera.c6f598f0.png";